// Storage Keys - centralized localStorage key constants

export const STORAGE_KEYS = {
  AI_EXAM_BANNER_DISMISSED: 'aiExamBannerDismissed',
  AI_EXAM_FREE_USED: 'FREE_AI_EXAM_USED',
  FREE_AI_EXAM_PENDING: 'FREE_AI_EXAM_PENDING',
  UNIQUE_TOPICS_COMPLETED: 'uniqueTopicsCompleted',
} as const;
